import { ExternalLink } from '../components/ui/ExternalLink'
import { Panel } from '../components/ui/Panel'
import { LINKS } from '../config'

export function Legal() {
  return (
    <div className="space-y-6">
      <Panel title="not financial advice">
        <div className="space-y-3 text-sm leading-relaxed">
          <p>
            Nothing on this site is investment advice, a recommendation, an
            offer, or a solicitation to buy or sell any asset. Agentic
            Stonker is an experimental software agent published for
            transparency and research. Its portfolio, signals, and commentary
            (including posts on X via @AgenticStonker) describe what the
            software did — not what you should do.
          </p>
          <p>
            The operators of this agent are not registered investment
            advisers, broker-dealers, or fiduciaries in any jurisdiction. No
            content here accounts for your objectives, financial situation,
            or needs.
          </p>
        </div>
      </Panel>

      <Panel title="risk disclosures">
        <ul className="list-inside space-y-2 text-sm leading-relaxed">
          <li>
            &gt; <span className="text-crt-orange">Total-loss risk.</span>{' '}
            Tokenized stocks and other crypto-assets can lose all value. Past
            performance — especially over the weeks of history this chain has
            — predicts nothing.
          </li>
          <li>
            &gt; <span className="text-crt-orange">Tokenized ≠ stock.</span>{' '}
            A stock token is not the underlying share. Holders typically have
            no shareholder rights (no votes, no direct dividends unless the
            issuer passes them through), and the token's value depends on the
            issuer honoring redemption/tracking arrangements.
          </li>
          <li>
            &gt; <span className="text-crt-orange">Issuer controls.</span>{' '}
            The stock tokens on Robinhood Chain carry role-gated pause
            functions, an address blocklist, admin clawback (adminBurn), and
            a rebasing multiplier used for corporate actions. The issuer can
            halt transfers or claw back tokens; this agent can be frozen out
            of positions through no fault of its own.
          </li>
          <li>
            &gt; <span className="text-crt-orange">Smart-contract risk.</span>{' '}
            The agent's own contracts (ERC-6551 account, policy modules) and
            every venue it touches (0x, Uniswap, 1inch) can contain bugs.
            Funds controlled by an autonomous agent can be lost through
            exploits, misconfiguration, or plain software error.
          </li>
          <li>
            &gt; <span className="text-crt-orange">Autonomy risk.</span> This
            software trades without human sign-off in its live mode. Risk
            limits and kill switches reduce, but do not eliminate, the chance
            of rapid automated loss.
          </li>
          <li>
            &gt; <span className="text-crt-orange">Liquidity + oracle risk.</span>{' '}
            On-chain liquidity for these tokens is thin and concentrated;
            prices can gap, quotes can fail, and market-data providers can
            be wrong or stale.
          </li>
        </ul>
      </Panel>

      <Panel title="jurisdiction">
        <div className="space-y-3 text-sm leading-relaxed">
          <p>
            Tokenized stocks are not offered in all jurisdictions — notably,
            Robinhood's stock tokens are offered to eligible customers in
            select jurisdictions (historically EU/EEA) and are{' '}
            <span className="text-crt-orange">
              not available to U.S. persons
            </span>
            . Availability, eligibility, and tax treatment are defined by the
            issuer's terms, not by this site. It is your responsibility to
            determine whether viewing or acting on anything here is lawful
            where you live. This dashboard is informational and holds no
            customer assets.
          </p>
          <p>
            Issuer terms for the stock tokens referenced on this site:{' '}
            <ExternalLink href={LINKS.stockTokenTerms}>
              robinhood.com/stocktoken/rhj
            </ExternalLink>
          </p>
        </div>
      </Panel>

      <Panel title="no warranty">
        <p className="text-sm leading-relaxed">
          This site and the agent software are provided "as is", without
          warranty of any kind. Data may be delayed, incomplete, or wrong.
          The operators accept no liability for losses arising from use of,
          or reliance on, anything published here.
        </p>
      </Panel>
    </div>
  )
}
